import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import CompanyInfoList from './deployCompany/deployCompany';  //deploy company component

class ViewCompanyDetails extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get Company',
                content: <GetInfo apiLink='companies/getOneCompany' isAllCompanies={true} param={true}/>,
                id: 0,
            }, {
                title: 'Company Details',
                content: <CompanyInfoList deployNotAllowed = {true}/>,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewCompanyDetails
